<template>
  <div id="user-form">
    <v-card :class="elevation">
      <v-toolbar dark color="primary" v-if="!register">
        <v-toolbar-title>{{ (!is_new && !!display.name) ? display.name : 'New User' }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon :disabled="!input" @click="edit = !edit">
          <v-icon>{{ edit ? 'mdi-pen' : 'mdi-pen-off' }}</v-icon>
        </v-btn>
        <v-btn icon disabled>
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <v-btn icon @click="close_dialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="py-2">
        <v-form v-model="form.valid">
          <v-row row wrap>
            <v-col cols="12">
              <v-text-field
                prepend-inner-icon="mdi-account"
                label="Name"
                name="name"
                id="name"
                type="text"
                outlined
                dense
                :readonly="readonly.name"
                :filled="readonly.name"
                :clearable="!readonly.name"
                :value="display.name"
                required
                :rules="rules.name"
                validate-on-blur
                @change="updates.name = $event"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                prepend-inner-icon="mdi-email"
                label="Email"
                name="email"
                id="email"
                type="email"
                outlined
                dense
                :readonly="readonly.email"
                :filled="readonly.email"
                :clearable="!readonly.email"
                :value="display.email"
                required
                :rules="rules.email"
                validate-on-blur
                @change="updates.email = $event"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                prepend-inner-icon="mdi-phone"
                label="Phone"
                name="phone"
                id="phone"
                type="phone"
                outlined
                dense
                :readonly="readonly.phone"
                :filled="readonly.phone"
                :clearable="!readonly.phone"
                :value="display.phone"
                required
                mask="phone"
                :rules="rules.phone"
                validate-on-blur
                @change="updates.phone = $event"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12" v-if="!register">
              <v-select
                prepend-inner-icon="mdi-drama-masks"
                :items="roles"
                label="Role"
                outlined
                dense
                :readonly="readonly.role"
                :filled="readonly.role"
                :value="display.role"
                required
                @change="updates.role = $event"
                hide-details="auto"
              ></v-select>
            </v-col>
          </v-row>
          <v-row row wrap v-if="!is_new">
            <v-col cols="12" sm="6">
              <v-text-field
                prepend-inner-icon="mdi-creation"
                label="Created"
                name="created"
                id="created"
                type="text"
                outlined
                dense
                readonly
                filled
                v-if="!!current"
                :value="current.created | date"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                prepend-inner-icon="mdi-update"
                label="Modofied"
                name="modified"
                id="modified"
                type="text"
                outlined
                dense
                readonly
                filled
                v-if="!!current"
                :value="current.modified | date"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row row wrap v-if="is_new">
            <v-col cols="12" sm="6">
              <v-text-field
                prepend-inner-icon="mdi-lock-outline"
                label="Password"
                name="password"
                id="password"
                type="password"
                outlined
                dense
                v-if="!input"
                validate-on-blur
                required
                :rules="rules.password"
                v-model="auth.password"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                prepend-inner-icon="mdi-lock"
                label="Confirm Password"
                name="confirmPassword"
                id="confirmPassword"
                type="password"
                outlined
                dense
                v-if="!input"
                validate-on-blur
                required
                :rules="rules.password"
                v-model="auth.repeated_password"
                :error-messages="passwordMatchError()"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-progress-linear :indeterminate="form.loading" v-if="form.loading"></v-progress-linear>
        </v-form>

      </v-card-text>

      <v-card-actions class="px-4" style="background-color: rgba(200,200,200,0.125);">
        <v-btn @click.native="close_dialog">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" :disabled="form_disabled" @click.native="submit_item">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import allrules from "@/resources/rules";
import parsers from "@/resources/parsers";
export default {
  props: {
      editable: Boolean, 
      input: {type: String, required: false, default: null},
      register: {type: Boolean, required: false, default: false}
    },

  data() {
    return {
      roles: [
        { text: "Fresh", value: "fresh" },
        { text: "User", value: "user" },
        { text: "Admin", value: "admin" }
      ],

      mutable: {
        key: { register: false, new: false, fresh: false, user: false, admin: false },
        name: { register: true, new: true, fresh: true, user: true, admin: true },
        email: { register: true, new: true, fresh: false, user: false, admin: false },
        phone: { register: true, new: true, fresh: false, user: true, admin: true },
        role: { register: false, new: true, fresh: false, user: false, admin: true },
        created: { register: false, new: false, fresh: false, user: false, admin: false },
        modified: { register: false, new: false, fresh: false, user: false, admin: false }
      },

      updates: {
        key: null,
        name: null,
        email: null,
        phone: null,
        role: null,
        created: null,
        modified: null
      },

      default: {
        key: null,
        name: null,
        email: null,
        phone: null,
        role: null,
        created: null,
        modified: null
      },

      auth: {
        password: null,
        repeated_password: null
      },

      form: {
        valid: false,
        loading: false
      },

      edit: this.editable
    };
  },

  computed: {
    user() {
      return this.$store.state.user.auth.user;
    },

    is_admin() {
      return this.$store.getters["user/auth/is_admin"];
    },

    is_new() {
      return !this.input;
    },

    elevation() {
      return this.register? 'elevation-0' : 'elevation-12'
    },

    current() {
      return this.$store.getters['user/admin/info']
    },

    entity() {
      return !this.is_new ?  this.current : this.default;
    },

    display() {
      let keys = Object.keys(this.default);
      return this.fallback(keys, [this.updates, this.entity]);
    },

    readonly() {
      let readonly = {};
      for (let key in this.mutable) {
        if (!this.edit) {
          readonly[key] = true;
        } else if (this.is_new) {
          readonly[key] = this.register
                            ? !this.mutable[key].register
                            : !this.mutable[key].new;
        } else {
          let role = this.user.role
          readonly[key] = !this.mutable[key][role];
        }
      }
      return readonly;
    },

    has_updates() {
      return Object.values(this.updates).some(x => !!x);
    },

    form_disabled() {
      return (
        !this.form.valid || this.form.loading || !this.edit || !this.has_updates
      );
    },

    rules() {
      return allrules;
    }
  },

  methods: {
    fallback(keys, cascade) {
      let result = {};
      for (let obj of cascade) {
        if (!!obj) {
          for (let key of keys) {
            result[key] = result[key] || obj[key];
          }
        }
      }
      return result;
    },

    initialize(obj, initial) {
      Object.keys(obj).forEach(k => (obj[k] = initial[k]));
    },

    get_user(key) {
      this.form.loading = true
      this.$store.dispatch('user/admin/get', key)
        .finally(() => {
          this.form.loading = false
        })
    },

    close_dialog() {
      this.initialize(this.updates, this.default);
      this.auth.password = null
      this.auth.repeated_password = null
      this.$emit("close", false);
    },

    submit_item() {
      (this.is_new) 
        ? (this.register) 
          ? this.register_item()
          : this.create_item() 
        : this.update_item()
    },

    register_item() {
      this.form.loading = true;

      let payload = {
        name: this.updates.name,
        email: this.updates.email,
        phone: this.updates.phone,
        password: this.auth.password
      };

      this.$store.dispatch('user/info/signup', payload)
        .then(response => {
          this.$emit("submit")
        })
        .finally(() => {
          this.form.loading = false;
          this.close_dialog();
        });
    },

    create_item() {
      this.form.loading = true;

      let payload = {
        name: this.updates.name,
        email: this.updates.email,
        phone: this.updates.phone,
        role: this.updates.role,
        password: this.auth.password
      };

      this.$store.dispatch('user/admin/create', payload)
        .then(response => {
          this.$emit("submit")
        })
        .finally(() => {
          this.form.loading = false;
          this.close_dialog();
        });
    },

    update_item() {
      this.form.loading = true;

      let payload = {};

      for (let key in this.updates) {
        if (!!this.updates[key]) {
          payload[key] = this.updates[key]
        }
      }

      this.$store.dispatch('user/admin/update', {key: this.entity.key, item: payload})
        .then(response => {
          this.$emit("submit")
        })
        .finally(() => {
          this.form.loading = false;
          this.close_dialog();
        });
    },

    passwordMatchError() {
      return this.auth.password === this.auth.repeated_password
        ? ""
        : "Passwords do not match";
    }
  },

  filters: {
    date: parsers.date
  },

  mounted() {
    if (!!this.input)
      this.get_user(this.input)
  }
};
</script>

<style>
.v-text-field__slot input {
  padding-left: 4px;
}
</style>